import { useEffect, useState } from "react";
import useAxios from "../../../../hooks/useAxios";
import Constants from "../../../../Constants";
import { getDashboardFilterQueryString } from "../../../../utils/helper";
import { useCompanyFilterContext } from "../../components/context/CompanyFilterContext";

export const useBadRecordsFailed = () => {
    const { filterParams } = useCompanyFilterContext();
    const { selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies } = filterParams;
    const { getData, isLoading } = useAxios();
    const [badRecordsData, setBadRecordsData] = useState([]);
    const [totalFailed, setTotalFailed] = useState(0);

    useEffect(() => {
        const fetchBadRecords = async () => {
            const baseUrl = Constants.ApiUrl.super.dashboard;
            const query = getDashboardFilterQueryString({ selectedRange, selectedTiers, selectedStatus, selectedAccountExecutive, selectedCompanies });
            try {
                const response = await getData(`${baseUrl.badRecords}?${query}`);
                if (!response?.success){
                    return;
                }
                const transformedData = (response?.byDatabase || []).map(item => ({
                    companyName: item.database,
                    value: item.count,
                    failedRecords: item.failedRecords
                }));
                setBadRecordsData(transformedData);
                setTotalFailed(response?.totalFailedRecord || 0);
            } catch (error) {
                setBadRecordsData([]);
                setTotalFailed(0);
                throw new Error(error);
            }
        };
        fetchBadRecords();
    }, [selectedRange, getData, selectedTiers, selectedStatus, selectedCompanies, selectedAccountExecutive]);

    return {
        isBadRecordsLoading: isLoading,
        totalFailed,
        badRecordsData
    };
};
